import {
  Avatar,
  Button,
  HeaderSectionItemButton,
  Icon,
  Popover,
  PopoverFooter,
  PopoverTitle,
  Text,
} from '@antoree/ant-ui';
import { NOTIFICATION, useCurrentUser, useNotificationContext } from 'contexts';
import { messaging } from 'firebaseClient';
import { removeFirebaseToken } from 'helpers';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';

const UserPopover: React.FC<{}> = () => {
  const [isUserMenuVisible, setIsUserMenuVisible] = useState(false);
  const history = useHistory();
  const { changeNotification } = useNotificationContext();
  const { displayName, firstName, avatarUrl } = useCurrentUser();

  const signOuthandler = () => {
    changeNotification(NOTIFICATION);
    messaging?.deleteToken();
    removeFirebaseToken();
    localStorage.removeItem('token');
    history.push('/sign-in');
  };
  const closeHandler = () => {
    setIsUserMenuVisible(false);
  };

  const toggleHandler = () => {
    setIsUserMenuVisible(!isUserMenuVisible);
  };

  return (
    <Popover
      id="userMemu"
      ownFocus
      repositionOnScroll
      button={
        <HeaderSectionItemButton
          aria-controls="userMemu"
          aria-expanded={isUserMenuVisible}
          aria-haspopup="true"
          aria-label="User menu"
          onClick={toggleHandler}
          style={{ border: '1px solid #CDCFD1', borderRadius: '40px' }}
        >
          <div>
            <Icon type="menu" className="mr-2" />
            <Avatar name={displayName} imageUrl={avatarUrl} size="m" />
          </div>
        </HeaderSectionItemButton>
      }
      isOpen={isUserMenuVisible}
      anchorPosition="downRight"
      closePopover={closeHandler}
    >
      <div style={{ width: 180 }}>
        <PopoverTitle>
          <FormattedMessage
            defaultMessage="Hello {firstName}!"
            values={{ firstName }}
          />
        </PopoverTitle>
        <Text size="s" color="subdued">
          <p>
            <span role="img" aria-label="icon">
              🚧
            </span>
            &nbsp;Coming soon....
          </p>
        </Text>
        <PopoverFooter>
          <Link to="/sign-in" onClick={signOuthandler}>
            <Button iconType="push" color="danger" fullWidth size="s">
              <FormattedMessage defaultMessage="Sign out" />
            </Button>
          </Link>
        </PopoverFooter>
      </div>
    </Popover>
  );
};

export default UserPopover;
